import { useIsExpress, useIsShippingOptionRequired, useShippingOption } from '../../state'
import { ShippingOptionStatus } from '../../model'
import { useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'

export const useShouldShowShippingMessage = (): boolean => {
  const isExpress = useIsExpress()
  const isShippingOptionRequired = useIsShippingOptionRequired()
  const { shippingOptionsStatus } = useShippingOption()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)

  const isShippingOptionNotSelected =
    isShippingOptionRequired && (shippingOptionsStatus < ShippingOptionStatus.UpdatingSelected || shippingOptionsStatus === ShippingOptionStatus.Error)
  const isCashThemeShippingOptionNotSelected = isArcadeDesignLanguage && isShippingOptionNotSelected

  if (!isExpress) {
    return false
  }

  if (isArcadeDesignLanguage) {
    return false
  }

  if (isCashThemeShippingOptionNotSelected) {
    return false
  }

  return isShippingOptionNotSelected || !isShippingOptionRequired
}
